import Vue from 'vue'
import Router from 'vue-router'
const login = resolve => require(['@/components/login/login'], resolve)
const index = resolve => require(['@/components/homePage/CourseCenter'], resolve)
const lessonpreparation = resolve => require(['@/components/homePage/lessonpreparation'], resolve)
const p_404 = resolve => require(['@/components/base/404.vue'], resolve) //404页面
const indexhowm= resolve => require(['@/components/homePage/indexhowm'], resolve)
const Personalsettings= resolve => require(['@/components/homePage/Personalsettings'], resolve)
const Courseobjectives=resolve => require(['@/components/homePage/Courseobjectives'], resolve)
const seeoneindex=resolve => require(['@/components/homePage/seeoneindex'], resolve)
const exporttext=resolve => require(['@/components/homePage/exporttext'], resolve)
const accountmags=resolve=> require(['@/components/homePage/accountmags'], resolve)
const Class_management=resolve=> require(['@/components/homePage/Class_management'], resolve)

Vue.use(Router)
export default new Router({
    routes: [

        {
            path: '/',
            name: 'login',
            component: login
        },

        {
            path: '/index',
            name: 'index',
            component: index
        },

        {
            path: '/Courseobjectives',
            name: 'Courseobjectives',
            component: Courseobjectives
        },
{
    path:'/Class_management',
    name:'Class_management',
    component: Class_management
},
        {
            path:'/accountmags',
            name:'accountmags',
            component: accountmags
        },

     {
       path: '/exporttext',
       name: 'exporttext',
        component: exporttext 
      },

        {
            path: '/seeoneindex',
            name: 'seeoneindex',
            component: seeoneindex
        },

        {
            path: '/indexhowm',
            name: 'indexhowm',
            component: indexhowm
        },

        {
            path: '/lessonpreparation',
            name: 'lessonpreparation',
            component: lessonpreparation
        },

        {
            path: '/Personalsettings',
            name: 'Personalsettings',
            component: Personalsettings
            
        },


        {
            path: '/404',
            name: 'p_404',
            component: p_404
        },
        

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js